<template>
  <div class="" style="">
    <div
      class="text-xs-center justify-content-center"
      style="
        margin-top: 14em;
        margin-left: 15em;
        position: fixed;
        z-index: 10000;
      "
      v-show="!isDataLoadedFirstTime"
    >
      <v-progress-circular
        style="right: 20px"
        indeterminate
        v-bind:size="70"
        v-bind:width="7"
        color="teal"
      ></v-progress-circular>
    </div>
    <div v-show="showBarChart" class="row bg-primary" style="">
      <div class="col-xs-12 bg-primary barchart-head" style="">
        <div class="col-sm-5 col-md-12 col-lg-4 barchart-header">
          <label class="barchart-label"
            >Distribution of
            <!-- <b>{{selectedIndicatorShortName}}</b> across {{theStateName}}, source: {{selectedSource}} {{sourceClicked}} - {{selectedYear}}</label> -->
            <b>{{ selectedIndicatorShortName }}</b> across {{ theStateName }}
            {{ sourceClicked }}
          </label>
          <label class="hidden">{{ indicatorSelected }}</label>
        </div>
        <div
          class="col-sm-7 col-md-12 col-lg-8 d-flex flex-row flex-md-column justify-content-md-around"
          style="height: auto; margin: 0; padding: 0"
        >
          <multi-select
            style="transform: scale(0.7); min-width:57%; fit-content;"
            v-model="selectedSource"
            :options="sourceOptions"
            :hide-selected="false"
            :searchable="true"
            :allow-empty="false"
            :show-labels="false"
            placeholder=""
          ></multi-select>
          <multi-select
            style="transform: scale(0.7); min-width:43%; fit-connect;"
            v-model="selectedYear"
            :options="optionYear"
            :hide-selected="false"
            :searchable="true"
            :allow-empty="false"
            :show-labels="false"
            placeholder=""
          ></multi-select>
        </div>
      </div>
    </div>

    <div class="row" v-show="showBarChart">
      <div
        class="chart-wrapper"
        style="border-top: none; border-bottom: none; border-right: none"
      >
        <div class="chart-stage">
          <div v-if="showToggle">
            <b-switch
              v-model="ndSwitch"
              true-value="ON"
              false-value="OFF"
              type="is-success"
              ><small style="font-size: smaller; color: black">
                Show numerator data</small
              ></b-switch
            >
            <!-- <b-switch
              v-model="ndSwitch"
              true-value="ON"
              false-value="OFF"
              v-tooltip.right="'Show numerator/denominator data'"
              >{{ ndSwitch }}</b-switch
            > -->
          </div>
          <highcharts
            :options="highchart_options"
            ref="highcharts"
          ></highcharts>
          <div
            class="targetInfo active_car_icon indicator_meta"
            v-tooltip.left="'Click to see target information'"
            @click="showTargetInfo = !showTargetInfo"
          >
            <svg style="width: 20px; height: 20px" viewBox="0 0 24 24">
              <path
                fill="#FFF"
                d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
              />
            </svg>
          </div>

          <div class="infoi" v-if="nodata">
            <br />
            <img src="static/img/noSubnationalData.png" style="width: 45%" />
            <br />
            <h3>NO SUB-NATIONAL LEVEL DATA</h3>
            <p>
              There is no sub-national data available for the indicator, data
              source and period you have selected. Try selecting another data
              source or period
            </p>
          </div>
          <!-- <div class="noSubDataMockUp" v-else-if="noSubData">
            <br>
                <img src="static/img/noSubnationalData.png" style="width:45%"/>
            <br>
              <h3>NO LGA LEVEL DATA</h3>
              <p>There is no LGA level data available for the indicator, data source, period and location you have selected. Try selecting another data source, period or location.</p>
          </div> -->

          <p class="extra small text-center" id="imp">
            <span class="mr-2" id="span-extra"></span>National Target (NT)
          </p>
          <!-- <plotly-vue v-bind="{layout: layout, traceArray: traceArray, options: plotlyOptions}"></plotly-vue> -->
        </div>
      </div>
    </div>
    <b-modal :active.sync="showTargetInfo" has-modal-card>
      <form action="">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-title-text">Information on Target Lines</p>
            <span
              @click="showTargetInfo = false"
              class="close-year-modal is-danger pull-right"
              ><v-icon>close</v-icon></span
            >
          </header>
          <section class="modal-card-body">
            <div class="panel panel-info">
              <div class="panel-heading">
                National Target - {{ nationalTarget }}
              </div>
              <div class="panel-body">
                <span>{{ nationalTargetInfo }}</span>
              </div>
            </div>
            <div class="panel panel-info">
              <div class="panel-heading">SDG Target - {{ sdgTarget }}</div>
              <div class="panel-body">
                <span>{{ SDGTargetInfo }}</span>
              </div>
            </div>
          </section>
          <!-- <footer class="modal-card-foot">
                  <button class="button is-danger pull-right" @click="showTargetInfo=false" type="button">CLOSE</button>
              </footer> -->
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import JQuery from "jquery";
let $ = JQuery;
import Fullscreen from "vue-fullscreen/src/component.vue";
import MultiSelect from "vue-multiselect";
import vueSlider from "vue-slider-component";
import { Carousel3d, Slide } from "vue-carousel-3d";
//import PlotlyVue from "@/components/Plotly";
import sortObjects from "@/assets/js-on/sortObjects";
import { chart_options } from "@/assets/js-on/highchart_options";
import statesVue from "./maptypes/states.vue";
import { log } from "async";
import { eventBus } from "../../../../main.js";
import { indDB } from "../../../../main";

export default {
  name: "barChartComponent",
  components: {
    Fullscreen,
    Carousel3d,
    Slide,
    MultiSelect,
    vueSlider,
  },
  // props: ["appData", "targetData", "lgaData","dashboardStateOptions",'metaData'],
  props: [
    "appData",
    "lgaData",
    "dashboardStateOptions",
    "metaData",
    "stateClicked",
    // "sourceOptions"
  ],
  data() {
    return {
      ndLgaUrl: "https://numerator-denominator-data.firebaseio.com/ndLga.json",
      ndIndexState: [],
      ndIndexLga: [],
      chartNd: [],
      showToggle: true,
      ndSwitch: "OFF",
      fullscreen: false,
      noSubData: false,
      lgaAvailable: true,
      showBarChart: true,
      highchart_options: chart_options,
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      ndStateData: JSON.parse(this.$ls.get("nd_state_data")),
      ndLgaData: "",
      isDataLoadedFirstTime: false,
      searchTerm: "",
      traceArray: [],
      lga: [],
      nodata: false,
      district: [],
      nationalTarget: "",
      sdgTarget: "",
      maxValue: 0,
      chartLength: 0,
      selectedIndicator: "Skilled attendance at delivery or birth",
      selectedYear: "2020",
      optionYear: [],
      sourceOptions: [
        "NHMIS",
        "NDHS",
        "MICS",
        "NNHS",
        "NARHS",
        "WHO-GHO",
        "World Bank",
        "IHME",
        "KDGHS"
      ],
      selectedState: "National",
      testData: {},
      optionStates: [
        "Abia",
        "Adamawa",
        "Akwa Ibom",
        "Anambra",
        "Bauchi",
        "Benue",
        "Borno",
        "National",
        "Bayelsa",
        "Cross River",
        "Delta",
        "Ebonyi",
        "Edo",
        "Ekiti",
        "Enugu",
        "FCT",
        "Gombe",
        "Imo",
        "Jigawa",
        "Kaduna",
        "Kebbi",
        "Kano",
        "Katsina",
        "Kogi",
        "Kwara",
        "Lagos",
        "Nasarawa",
        "Niger",
        "Ogun",
        "Ondo",
        "Osun",
        "Oyo",
        "Plateau",
        "Rivers",
        "Sokoto",
        "Taraba",
        "Yobe",
        "Zamfara",
      ],
      statesToShortCode: {
        Abia: "AB",
        Adamawa: "AD",
        "Akwa Ibom": "AK",
        Anambra: "AN",
        Bauchi: "BA",
        Benue: "BE",
        Borno: "BO",
        Bauchi: "BA",
        Bayelsa: "BY",
        "Cross River": "CR",
        Delta: "DE",
        Ebonyi: "EB",
        Edo: "ED",
        Ekiti: "EK",
        Enugu: "EN",
        FCT: "FC",
        Gombe: "GO",
        Imo: "IM",
        Jigawa: "JI",
        Kano: "KN",
        Katsina: "KT",
        Kaduna: "KD",
        Kebbi: "KE",
        Kogi: "KO",
        Kwara: "KW",
        Lagos: "LA",
        Nasarawa: "NA",
        Niger: "NI",
        Ogun: "OG",
        Ondo: "ON",
        Osun: "OS",
        Oyo: "OY",
        Plateau: "PL",
        Rivers: "RI",
        Sokoto: "SO",
        Taraba: "TA",
        Yobe: "YO",
        Zamfara: "ZA",
      },
      headerObj: {},
      showTargetInfo: false,
      nationalTargetInfo: "",
      SDGTargetInfo: "",
      selectedSource: "NHMIS",
      sourceClickProp: null,
      plotData: {},
      tableColumnHeaderAttr: null,
      options: [
        // {
        //     programArea: 'program area name',
        //     indicators: [
        //         { name: 'indicator name'}
        //     ]
        // }
      ],
      value: [],
      theStateName: "the country",
      highchart_options: {
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 380,
              },
              chartOptions: {},
            },
          ],
        },
        chart: {
          type: "bar",
          zoomType: "xy",
          borderColor: "#FFFFFF",
          events: {
            drillup: (e) => {
              document
                .querySelector("p#imp")
                .setAttribute("style", "display:none;");
              this.theStateName = "the country";
              this.noSubData = false;
            },
            drilldown: (e) => {
              document
                .querySelector("p#imp")
                .setAttribute("style", "display:block;");
              this.theStateName = `${e.seriesOptions.name} state`;

              // if (
              //   this.lgaAvailable == false ||
              //   this.highchart_options.drilldown.series[0].data.length == 0 ||
              //   this.highchart_options.drilldown.series[0].data[0].y ==
              //     undefined
              // ) {
              //   this.noSubData = true;
              // } else {
              //   this.noSubData = false;
              // }
              // if (this.nodata == true) {
              //   this.noSubData = false;
              // }
            },
          },
        },
        lang: {
          drillUpText: "Back to States",
          noData:
            "<div style='text-align:center !important; border: 2px solid gray;padding:10%;width: 120%;height: 120%;' class='noSubDataMockUp'><img alt='No data Image' style='width:45%;' src='static/img/noSubnationalData.png'><br><h3 style=' text-align: center;'>NO SUB-NATIONAL <br> LEVEL DATA</h3><br><p style='font-size:13px;font-weight: 200;text-align: center;padding-bottom:4%'>There is no sub-national data available <br>for the indicator,  data source <br> and period you have <br> selected. Try selecting another <br> data source or period</p></div>",
        },
        noData: {
          style: {},
          position: {
            x: -25,
            y: -30,
          },
          useHTML: true,
        },
        title: {
          margin: 25,
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600",
          },
        },
        subtitle: {
          text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.',
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: "category",
          //categories: null,
          title: {
            text: "x-axis title",
          },
          labels: {
            style: {
              fontSize: "9px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "600",
              color: "#999999",
            },
          },
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          plotLines: [],
          title: {
            text: "y-axis title",
            style: {
              fontSize: "11px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal",
              color: "#888888",
            },
          },
          labels: {
            style: {
              fontSize: "10px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal",
              color: "#888888",
            },
          },
        },
        legend: {
          enabled: true,
          borderColor: "black",
          //   borderRadius: 10,
          borderWidth: 3,
          title: {
            text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
            style: {
              fontSize: "12px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "600",
              color: "#666666",
            },
          },
        },
        plotOptions: {
          series: {
            events: {
              // legendItemClick: function (e) {
              //     this.visible = !this.visible;
              //     var visibility = this.visible ? 'visible' : 'hidden';
              //     // if (!confirm('The series is currently ' +
              //     //              visibility + '. Do you want to change that?')) {
              //     //     return true;
              //     // }
              // }
            },
            borderWidth: 0,
            point: {
              events: {
                click: function (e) {
                  // console.log(e);
                },
              },
            },
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              borderWidth: 0,
              crop: false,
              overflow: "allow",
              padding: 1,
              format: "{point.y:.1f}",
              style: {
                fontSize: "8px",
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: "normal",
                color: "#555555",
              },
            },

            // states: {
            //     hover: {
            //         enabled: true,
            //         lineWidth: 4
            //     }
            // },
            zones: [],
          },
        },
        tooltip: {
          // backgroundColor: '#FCFFC5',
          // borderColor: 'black',
          // borderRadius: 10,
          // borderWidth: 3,
          // crosshairs: [true, true],
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>',
        },
        // navigation: {
        //     menuItemStyle: {
        //         fontSize: '10px'
        //     }
        // },
        series: [],
        drilldown: {
          activeAxisLabelStyle: {
            color: "black",
            textDecoration: "none",
            fontWeight: "normal",
          },
          activeDataLabelStyle: {
            color: "black",
            textDecoration: "none",
            fontWeight: "normal",
          },
          series: [
            {
              name: "Anambra",
              id: "Anambra",
              data: [
                ["v65.0", 0.1],
                ["v64.0", 1.3],
                ["v63.0", 53.02],
                ["v62.0", 1.4],
                ["v61.0", 0.88],
                ["v60.0", 0.56],
                ["v59.0", 0.45],
                ["v58.0", 0.49],
                ["v57.0", 0.32],
                ["v56.0", 0.29],
                ["v55.0", 0.79],
                ["v54.0", 0.18],
                ["v51.0", 0.13],
                ["v49.0", 2.16],
                ["v48.0", 0.13],
                ["v47.0", 0.11],
                ["v43.0", 0.17],
                ["v29.0", 0.26],
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    async getIdb() {
      var closeFriends;
      await indDB
        .transaction("rw", indDB.stateNumDen, function* () {
          closeFriends = yield indDB.stateNumDen.toArray();
        })
        .catch(function (err) {
          // Catch any error event or exception and log it:
          //console.error(err.stack || err);
        });
      //console.log(closeFriends)
      return closeFriends;
    },
    async fetchNdLgaData() {
      return this.axios.get(this.ndLgaUrl);
    },
    getIndicatorSourceIndex(data) {
      //let list = this.lsNdStateData[0]
      //console.log(list)
      let check = this.selectedIndicator + " -> " + this.selectedSource;
      // console.log(check)
      // console.log(data[0])
      return data[0].indexOf(check);
    },
    ndFilterByYear(data) {
      return data.filter((val) => val[0] == this.selectedYear);
      //console.log(ndYearData)
    },
    thousandSeperator(x) {
      //return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return Number(x).toLocaleString();
    },

    getNdChartData() {},

    plotLgaND() {
      let lgaData = this.ndFilterByYear(this.ndLgaData);
      let lgaIndex = this.ndIndexLga;

      if (lgaData.length > 0) {
        var ivt =
          this.$store.state.CAR.indicatorAttributesOtherSources[
            this.selectedIndicator
          ];
        var vt = ivt[1] === "P" ? "%" : "";
        var it = ivt[1] === "P" ? "%" : "";

        let highChartSeries = this.highchart_options.series;

        // num-den data for LGA
        if (this.ndSwitch == "ON") {
          // console.log(ivt)

          //Adds the num/den data to the highchart series when there is no national target
          //when there is no national target highChartSeries.length==2 and data is in the second index
          //when there is a national target highChartSeries.length==4 and there is nothing in the 4th index

          // if (highChartSeries.length == 2){
          //   for (let x = 0; x < highChartSeries.length ; x++) {
          //     for (let y = 0; y < highChartSeries[x].data.length; y++) {
          //       let lgaName = highChartSeries[x].data[y].name;

          //       // filters ndLgadata with all the locations to return data for each location
          //       let value = lgaData.filter(val => {
          //         val[1] == highChartSeries[x].data[y].name
          //       });
          //       // console.log(value)

          //       value = value[0][lgaIndex].split("#");
          //       //loops through value[0](numerator data) and adds , seperator
          //       let numData = this.thousandSeperator(value[0]);
          //       let denData = this.thousandSeperator(value[1]);
          //       console.log(numData);
          //       console.log(denData)
          //       highChartSeries[x].data[y].nd = numData;
          //       highChartSeries[x].data[y].dn = denData;
          //     }
          //   }
          //   //console.log(highChartSeries)

          //   this.highchart_options.plotOptions.series.dataLabels.format =
          //     "<b>" + "{point.y:.1f}" + vt + "</b>" + "  (" + "{point.nd}" + ")";
          //   this.highchart_options.tooltip.pointFormat =
          //     '<span style="font-size:10px; color:black;">' +
          //     "{point.name}:" +
          //     " {point.y:.2f}" +
          //     it +
          //     "<br>" +
          //     '<span style="font-size:10px; color:black;">' +
          //     "(" +
          //     "{point.nd} " +
          //     this.of +
          //     " {point.dn}" +
          //     ")" +
          //     "</span>";
          // }

          for (let x = 0; x < highChartSeries.length - 1; x++) {
            for (let y = 0; y < highChartSeries[x].data.length; y++) {
              let location = highChartSeries[x].data[y].name;
              //console.log(location)

              // filters lgaData with all the locations to return data for each location
              let value = this.lgaData.filter((val) => {
                val[1] == highChartSeries[x].data[y].name;
              });
              //console.log(value)

              value = value[0][lgaIndex].split("#");
              //loops through value[0](numerator data) and adds , seperator
              let numData = this.thousandSeperator(value[0]);
              let denData = this.thousandSeperator(value[1]);
              console.log(numData);
              console.log(denData);

              highChartSeries[x].data[y].nd = numData;
              highChartSeries[x].data[y].dn = denData;
            }
          }
          // console.log(highChartSeries)

          // This shows the num/den values inside brackets on the charts
          this.highchart_options.plotOptions.series.dataLabels.format =
            "<b>" + "{point.y:.1f}" + vt + "</b>" + "  (" + "{point.nd}" + ")";

          //Add num/den data to the tooltip
          this.highchart_options.tooltip.pointFormat =
            '<span style="font-size:10px; color:black;">' +
            "{point.name}:" +
            " {point.y:.2f}" +
            it +
            "<br>" +
            '<span style="font-size:10px; color:black;">' +
            "(" +
            "{point.nd} " +
            "of" +
            " {point.dn}" +
            ")" +
            "</span>";
        }
        //clears the num/den values and bracket from the chart
        else if (this.ndSwitch == "OFF") {
          this.highchart_options.tooltip.pointFormat =
            '<span style="font-size:10px; color:black;">{point.name}:  {point.y:.2f}' +
            it +
            " </span><br/>";
        }
      } else {
        console.log(`NO DATA FOR ${this.selectedYear}`);
        this.nodata = true;
        if (this.ndSwitch == "OFF") {
          this.nodata = false;
        }
      }
    },

    async plotStateND() {
      this.ndStateData = await this.getIdb();
      let indexx = this.getIndicatorSourceIndex(this.ndStateData);
      this.ndStateData = this.ndFilterByYear(this.ndStateData);
      var ivt =
        this.$store.state.CAR.indicatorAttributesOtherSources[
          this.selectedIndicator
        ];
      var vt = ivt[1] === "P" ? "%" : "";
      var it = ivt[1] === "P" ? "%" : "";
      // console.log(indexx)
      // console.log(this.ndStateData)
      // console.log(this.highchart_options.series)
      if (this.ndSwitch == "ON") {
        //console.log(this.highchart_options.series)

        //Adds the num/den data to the highchart series when there is no national target
        //when there is no national target this.highchart_options.series.length==2 and data is in the second index
        //when there is a national target this.highchart_options.series.length==4 and there is nothing in the 4th index

        if (this.highchart_options.series.length == 2) {
          for (let x = 0; x < this.highchart_options.series.length; x++) {
            for (
              let y = 0;
              y < this.highchart_options.series[x].data.length;
              y++
            ) {
              let location = this.highchart_options.series[x].data[y].name;
              //console.log(location)
              // filters ndStatedata with all the locations to return data for each location
              let value = this.ndStateData.filter(
                (val) => val[1] == this.highchart_options.series[x].data[y].name
              );
              value = value[0][indexx].split("#");
              //loops through value[o](numerator data) and adds , seperator
              let numData = this.thousandSeperator(value[0]);
              let denData = this.thousandSeperator(value[1]);
              //console.log(numData);
              //console.log(denData)
              this.highchart_options.series[x].data[y].nd = numData;
              this.highchart_options.series[x].data[y].dn = denData;
              }
          }
          //console.log(this.highchart_options.series)

          this.highchart_options.plotOptions.series.dataLabels.format =
            "<b>" + "{point.y:.1f}" + vt + "</b>" + "  (" + "{point.nd}" + ")";
          this.highchart_options.tooltip.pointFormat =
            '<span style="font-size:10px; color:black;">' +
            "{point.name}:" +
            " {point.y:.2f}" +
            it +
            "<br>" +
            '<span style="font-size:10px; color:black;">' +
            "(" +
            "{point.nd} " +
            this.of +
            " {point.dn}" +
            ")" +
            "</span>";
        }
        for (let x = 0; x < this.highchart_options.series.length - 1; x++) {
          for (
            let y = 0;
            y < this.highchart_options.series[x].data.length;
            y++
          ) {
            let location = this.highchart_options.series[x].data[y].name;
            //console.log(location)
            // filters ndStatedata with all the locations to return data for each location
            let value = this.ndStateData.filter(
              (val) => val[1] == this.highchart_options.series[x].data[y].name
            );
            //console.log(value[0][13])
            value = value[0][indexx].split("#");
            //loops through value[o](numerator data) and adds , seperator
            let numData = this.thousandSeperator(value[0]);
            let denData = this.thousandSeperator(value[1]);
            //console.log(numData);
            //console.log(denData)
            this.highchart_options.series[x].data[y].nd = numData;
            this.highchart_options.series[x].data[y].dn = denData;
          }
        }
        // console.log(this.highchart_options.series)

        // This shows the num/den values inside brackets on the charts
        this.highchart_options.plotOptions.series.dataLabels.format =
          "<b>" + "{point.y:.1f}" + vt + "</b>" + "  (" + "{point.nd}" + ")";

        //Add num/den data to the tooltip
        this.highchart_options.tooltip.pointFormat =
          '<span style="font-size:10px; color:black;">' +
          "{point.name}:" +
          " {point.y:.2f}" +
          it +
          "<br>" +
          '<span style="font-size:10px; color:black;">' +
          "(" +
          "{point.nd} " +
          "of" +
          " {point.dn}" +
          ")" +
          "</span>";
      }
      //clears the num/den values and bracket from the chart
      else if (this.ndSwitch == "OFF") {
        this.highchart_options.tooltip.pointFormat =
          '<span style="font-size:10px; color:black;">{point.name}:  {point.y:.2f}' +
          it +
          " </span><br/>";
      }
    },
    toggle() {
      // this.$refs['fullscreen'].background = "green";
      this.$refs["fullscreen"].toggle();
    },
    //Method to hide or show the bar chart
    hideBar() {
      this.$emit("barChartBoolValue", this.showBarChart);
      this.showBarChart = !this.showBarChart;
    },
    enter() {
      return true;
    },
    convertToObject(arrayData, arrayDataName) {
      var tempCadre = [];

      for (var i = 0; i < arrayData.length; i++) {
        var data = {
          name: arrayDataName[i],
          y: arrayData[i],
          drilldown: arrayDataName[i],
        };
        // console.log(data.y); //Second try

        tempCadre.push(data);

        /* Implementation of national drill down to states data */
        let drillColor = "#58a5e8";
        // let drillColor = "";

        if (arrayDataName[0] !== "National") {
          if (arrayData[i] >= this.nationalTarget) {
            drillColor = "#13b433";
          }
          if (arrayData[i] < this.nationalTarget) {
            drillColor = "#e85d58";
          }
          // else{
          //   drillColor = "#1E70EC";
          // }

          let natDrillData = {
            name: arrayDataName[i],
            y: arrayData[i],
            color: drillColor,
          };
          this.highchart_options.drilldown.series[7].data.push(natDrillData);
        }
        /* End implementation of national drill down to states data */
      }
      let indexed = 0;
      arrayData.forEach(function (item, index, array) {
        if (parseInt(item) === 0) {
          indexed++;
        }
      });
      // console.log(arrayData);
      // console.log(indexed);
      if (indexed === 37) {
        this.nodata = true;
      } else {
        this.nodata = false;
      }
      return tempCadre;
    },
    getDrilldownData() {
      //Applying slice to create a new instance of the lgaData
      var tempLGAdata = this.lga.slice(0);
      var series_drilldownDataPerState = [];
      this.highchart_options.drilldown.series = [];
      var indicatorAndSourceValueByState = {};
      this.optionStates.map((elem, index) => {
        indicatorAndSourceValueByState[elem] = [];
      });
      // console.log(indicatorAndSourceValueByState);

      // get the values of the indicators by state and by year
      tempLGAdata.map((elem, index) => {
        var stateName = elem[1];

        if (stateName !== "State") {
          var rowDataWithoutState = elem.slice(0);
          rowDataWithoutState.splice(1, 1); // remove the state name
          indicatorAndSourceValueByState[stateName].push(rowDataWithoutState);
        }
      });
      var indicatorSource =
        this.selectedIndicator + " -> " + this.selectedSource;
      // console.log(this.selectedIndicator);
      //get index of selected indicator
      if (this.lgaData !== null && this.lgaData[0] !== undefined) {
        var indexOfindicatorSource =
          this.lgaData[0].indexOf(indicatorSource) - 1;
      }
      // console.log(this.lgaData[0]); //i think this is the place

      // console.log(indexOfindicatorSource + ' ' + this.selectedSource + this.lgaData[0]);
      // if(indexOfindicatorSource <= 40){
      //   indexOfindicatorSource = indexOfindicatorSource + 1
      // }

      // console.log(this.lgaData[0].indexOf(indicatorSource) - 1);

      var stateDataByYear = [];
      this.optionStates.map((elem, index) => {
        //get array of LGA by states and year
        // console.log(elem);
        stateDataByYear[elem] = [];
        indicatorAndSourceValueByState[elem].map((element, index) => {
          // console.log(element[1]);
          this.noSubData = false;
          if (element[0] === parseInt(this.selectedYear)) {
            //this.nodata = true;
            stateDataByYear[elem].push(element);
          }
        });
        var drilldownDataPerState = [];
        stateDataByYear[elem].forEach((element) => {
          var tempData = [];
          var elementName = element[1].substring(0, element[1].length - 3);
          // console.log(element[indexOfindicatorSource]);
          // console.log(element.length);
          if (element[indexOfindicatorSource] !== "") {
            // console.log(elementName);
            //  this.lgaAvailable = true;
            drilldownDataPerState.push({
              name: elementName,
              y: element[indexOfindicatorSource],
              color: this.getColorForLGA(
                element[indexOfindicatorSource],
                this.nationalTarget !== "" ? this.nationalTarget : 0
              ),
            });
          } else {
            //this.lgaAvailable = false;
          }
        });
        var drilldownData = {
          name: elem,
          // name: "On Target",
          // color:
          id: elem,
          data: drilldownDataPerState,
        };
        var drilldownData2 = {
          name: elem,
          name: "Not on target",
          // color:
          id: elem,
          data: drilldownDataPerState,
        };
        series_drilldownDataPerState.push(drilldownData);
        // series_drilldownDataPerState2.push(drilldownData2);

        // if( drilldownData2.data[58] !== ''){
        //   this.nodata = true;
        // }
      });

      // var tempArr = series_drilldownDataPerState;
      series_drilldownDataPerState.forEach((element) => {
        element.data.sort((a, b) => {
          // this.testData = b;
          // console.log(this.testData);
          return b.y - a.y;
        });
      });

      //sort array of objects by value
      var tempArr = series_drilldownDataPerState;
      tempArr.forEach((element) => {
        element.data.sort((a, b) => {
          return b.y - a.y;
        });
      });

      //  this.testData = series_drilldownDataPerState;
      //  console.log(this.highchart_options);

      this.highchart_options.drilldown.series = series_drilldownDataPerState;

      // this.testData = console.log(this.highchart_options.series[1]);

      if (this.highchart_options.drilldown.series[1].data.length === 0) {
        this.nodata = true;
      } else {
        this.nodata = false;
      }
    },
    getColorForLGA(data, target) {
      var indicatorSignalType =
        this.$store.state.CAR.indicatorAttributesOtherSources[
          this.selectedIndicator
        ];
      var colorType = ["#13b433", "#1E70EC", "#e85d58"]; // G, B, R

      var color = [];
      if (indicatorSignalType[0][0] === "G") {
        color = [0, 2];
      } else {
        color = [2, 0];
      }
      if (target > 0) {
        if (data > target) {
          return colorType[color[0]];
        } else if (data < target) {
          return colorType[color[1]];
        }
      } else {
        return colorType[1];
      }
    },
    getDisplayFactor() {
      let displayFactor = "";
      for (const i in this.metaData) {
        if (this.metaData[i][0] === this.selectedIndicator) {
          displayFactor = this.metaData[i][3];

          //set target info
          this.nationalTargetInfo = this.metaData[i][9];
          this.SDGtargetInfo = this.metaData[i][11];
          //console.log(this.SDGtargetInfo);

          break;
        }
      }
      this.highchart_options.yAxis.title.text = displayFactor;
    },
    splitLGADistrict() {
      var lgaDistrict = this.lgaData;
      if (lgaDistrict !== null) {
        lgaDistrict.map((elem) => {
          var theLGADist = elem[2].split(" ");
          theLGADist = theLGADist[theLGADist.length - 1];
          // console.log(theLGADist);
          if (theLGADist === "LGA") {
            this.lga.push(elem);
            // console.log(elem);
          }
          if (theLGADist === "Dist.") {
            this.district.push(elem);
          }
        });
      }
    },
    sortByLatestAvailableYear() {
      let years = [];
      let rightOptions = [];
      for (var one in this.sourceOptions) {
        rightOptions[one] = {
          name: this.sourceOptions[one],
          yrs: [],
        };
      }
      for (var item in rightOptions) {
        let theYears = [];
        let statesByIndicatorByYear =
          this.$store.getters.getCurrentIndicatorsValue;
        let indicatorSource =
          this.selectedIndicator + " -> " + rightOptions[item].name;
        let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
        for (var i in statesByIndicatorByYear) {
          statesByIndicatorByYear[i].map((el, i) => {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (theYears.indexOf(el[0]) < 0) {
                theYears.push(el[0]);
              }
            }
          });
        }
        rightOptions[item].yrs.push(
          theYears.sort(function (a, b) {
            return b - a;
          })
        );
      }
      // console.log(rightOptions);
      var latestYrs = [];

      for (var opt in rightOptions) {
        if (rightOptions[opt].yrs[0][0] !== undefined) {
          latestYrs.push(rightOptions[opt].yrs[0][0]);
        }
      }
      var temp = [];
      for (var val in rightOptions) {
        if (rightOptions[val].yrs[0][0] == Math.max(...latestYrs)) {
          //console.log(rightOptions)
          this.selectedSource = rightOptions[val].name;
          if (this.selectedSource == "NHMIS") break;
        }
      }
      //console.log(temp);
      if (temp.includes("NHMIS")) {
        this.selectedSource = "NHMIS";
      }
    },

    // This function returns the first year for each source
    getSourceYear(data) {
      let years = [];
      let rightOptions = [];
      for (var one in this.sourceOptions) {
        rightOptions[one] = {
          name: this.sourceOptions[one],
          yrs: [],
        };
      }
      for (var item in rightOptions) {
        let theYears = [];
        let statesByIndicatorByYear =
          this.$store.getters.getCurrentIndicatorsValue;
        let indicatorSource =
          this.selectedIndicator + " -> " + rightOptions[item].name;
        let indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
        for (var i in statesByIndicatorByYear) {
          statesByIndicatorByYear[i].map((el, i) => {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (theYears.indexOf(el[0]) < 0) {
                theYears.push(el[0]);
              }
            }
          });
        }
        rightOptions[item].yrs.push(
          theYears.sort(function (a, b) {
            return b - a;
          })
        );
      }

      if (
        rightOptions[this.sourceOptions.indexOf(data)] !== -1 ||
        rightOptions[this.sourceOptions.indexOf(data)] !== undefined
      ) {
        return rightOptions[this.sourceOptions.indexOf(data)].yrs[0][0];
      }
    },

    plotStateChart() {
      this.ndSwitch = "OFF";
      if (this.stateClicked === "National") {
        if (this.selectedSource == "NHMIS (monthly)") {
          this.plotNhmisMonthly(this.selectedIndicator);
        } else {
          this.theStateName = "the country";
          eventBus.$emit("changedStateName", this.theStateName);
          document.querySelector("#imp").setAttribute("style", "display:none;");
          this.getDrilldownData();
          this.noSubData = false;
          var ivt =
            this.$store.state.CAR.indicatorAttributesOtherSources[
              this.selectedIndicator
            ];
          var vt = ivt[1] === "P" ? "%" : "";
          var it = ivt[1] === "P" ? "%" : "";
          var stateByIndicatorByYear =
            this.$store.getters.getCurrentIndicatorsValue;
          var selectedIndicatorValuesForEachState = {};

          var indicatorSource =
            this.selectedIndicator + " -> " + this.selectedSource;
          var indexOfindicatorSource =
            this.lsData[0].indexOf(indicatorSource) - 1;
          // get the current year with values for each indicator...
          var statesWithIndicatorsYearAndValues =
            this.getYearWithCurrentIndicatorValues(
              indexOfindicatorSource,
              stateByIndicatorByYear
            );

          // what is the idea behind this?
          if (statesWithIndicatorsYearAndValues[1] !== -Infinity) {
            for (var stateName in stateByIndicatorByYear) {
              if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
                // var len = stateByIndicatorByYear[o].length;
                var stateCurrentYearVals =
                  stateByIndicatorByYear[stateName][
                    statesWithIndicatorsYearAndValues[2][stateName]
                  ];
                selectedIndicatorValuesForEachState[stateName] = [
                  stateCurrentYearVals[0],
                  stateCurrentYearVals[indexOfindicatorSource],
                ]; // stateByIndicatorByYear[stateName][len - 1]
              }
            }
          } else {
            selectedIndicatorValuesForEachState =
              statesWithIndicatorsYearAndValues[0];
          }

          var temp = Object.keys(selectedIndicatorValuesForEachState);
          var obj = {};
          var statesValue;
          temp.map((elem, index) => {
            statesValue = selectedIndicatorValuesForEachState[elem][1];
            obj[elem] = statesValue; //? statesValue: ""; //selectedIndicatorValuesForEachState[elem][1];
          });
          var regions = [
            "North-East",
            "North-West",
            "North-Central",
            "South-East",
            "South-West",
            "South-South",
          ];
          var sortedObj = sortObjects(obj); // custom method
          var xAxis = [],
            yAxis = [];
          for (let stateName in sortedObj) {
            if (sortedObj.hasOwnProperty(stateName)) {
              if (regions.indexOf(stateName) < 0) {
                // don't need the regions in this chart
                yAxis.push(stateName);
                xAxis.push(sortedObj[stateName] ? sortedObj[stateName] : null);
              }
            }
          }
          // console.log(yAxis);
          var plotData = {};
          // get the data required for ngMap
          yAxis.map((elem, index) => {
            plotData[elem] = xAxis[index] ? xAxis[index] : 0;
          });
          this.$emit("plotData", plotData);
          var new_yAxis = yAxis.slice(0),
            new_xAxis = xAxis.slice(0);
          for (var i in yAxis) {
            if (yAxis[i] === "National") {
              var tempName = yAxis[i];
              var tempValue = xAxis[i];
              new_yAxis.splice(i, 1);
              new_yAxis.unshift(tempName);
              new_xAxis.splice(i, 1);
              new_xAxis.unshift(tempValue);
            }
          }
          // extract the top5, least5 and others
          // var cadre = this.computeCadre(xAxis, yAxis);
          var cadre2 = this.computeCadre2(xAxis, yAxis);
          var indicatorSignalType =
            this.$store.state.CAR.indicatorAttributesOtherSources[
              this.selectedIndicator
            ];

          var colorType = ["#13b433", "#1E70EC", "#e85d58"]; // G, B, R
          let legendText = [
            "On target",
            "Target not Available",
            "Not on target",
          ];

          var color = [];
          let text = [];
          if (indicatorSignalType[0][0] === "G") {
            color = [0, 2];
          } else {
            color = [2, 0];
          }
          // for highchart...

          if (
            vt === "%" &&
            this.stateClicked === "National" &&
            this.maxValue < 100
          ) {
            this.highchart_options.yAxis.max = 100 + 10;
          } else {
            this.highchart_options.yAxis.max = null;
          }
          this.highchart_options.series = [];
          this.highchart_options.title.text = this.selectedIndicatorShortName;
          this.highchart_options.subtitle.text =
            this.selectedSource + " - " + this.selectedYear;
          this.highchart_options.yAxis.plotLines = [];
          (this.highchart_options.yAxis.gridLineWidth = 0), //Remove gridlines
            // this.highchart_options.yAxis.minorGridLineWidth= 0;    //Insignificant here
            (this.highchart_options.tooltip.headerFormat =
              '<span style="font-size:12px; font-weight:bold;">{series.name}</span><br>');
          this.highchart_options.tooltip.pointFormat =
            '<span style="font-size:10px; color:black;">{point.name}:  {point.y:.2f}' +
            it +
            " </span><br/>";
          this.highchart_options.plotOptions.series.dataLabels.format =
            "{point.y:.1f}" + vt;

          this.highchart_options.yAxis.softMax = "";
          this.highchart_options.exporting = {
            allowHTML: "true",
            buttons: {
              //     toggleButton: {
              //     text: 'ON',
              //     text: 'NUM/DEN',
              //     onclick: function () {
              //       eventBus.$emit("nd")
              //       // this.enterdp();
              //         // alert(this.theStateName);
              //         console.log(this.theStateName);
              //     },
              //     theme: {
              //       padding: 30
              //       padding: 20
              //     },
              //     align: "left"

              // },
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  //"viewData",
                  "openInCloud",
                ],

                symbol: "download",
                // symbolStrokeWidth: 2,
                // symbolFill: '#330033',
                // symbolStroke: '#b3d4fc'
              },
            },
            filename:
              this.selectedIndicator +
              " (" +
              this.selectedSource +
              " - " +
              this.selectedYear +
              ")",
          };

          if (xAxis[0] < cadre2.nationalTarget) {
            this.highchart_options.yAxis.softMax = cadre2.nationalTarget + 10;
          }
          //   var statesNameInOrder = (cadre.top5_yAxis.reverse().concat(cadre.others_yAxis.reverse()))
          //                           .concat(cadre.least5_yAxis.reverse());
          //   var statesValuesInOrder = (cadre.top5_xAxis.reverse().concat(cadre.others_xAxis.reverse()))
          //                             .concat(cadre.least5_xAxis.reverse());

          let nationalLineID = "natID";
          var nationalTargetLine = {
            // id: 'L1',
            id: nationalLineID,
            color: "#222222",
            width: 0.5,
            value: cadre2.nationalTarget,
            label: {
              text: "NT: " + cadre2.nationalTarget + vt, // vt is value type; whether percentage or number
              verticalAlign: "top",
              rotation: 0,
              textAlign: "left",
              y: 0, //y: -475, on mobile
              x: -20,
              style: {
                fontSize: "10px",
                fontFamily: '"Open Sans", sans-serif',
              },
            },
          };

          var sdgTargetLine = {
            id: "L2",
            color: "#222222",
            width: 0.5,
            value: cadre2.sdgTarget,
            dashStyle: "longdashdot",
            label: {
              text: "SDG: " + cadre2.sdgTarget + vt, // vt is value type; whether percentage or number
              verticalAlign: "top",
              rotation: 0,
              textAlign: "right",
              y: 0,
              x: 0,
              style: {
                fontSize: "10px",
                fontFamily: '"Open Sans", sans-serif',
              },
            },
          };

          //Series for target Legend
          let nationalTargetLegend = {
            // Series that mimics the plot line
            color: "#222222",
            name: "National Target (NT)",
            // dashStyle: 'shortdash',
            marker: {
              symbol: "triangle",
            },
            events: {
              legendItemClick: function (e) {
                if (this.visible) {
                  e.target.chart.yAxis[0].removePlotLine(nationalLineID);
                } else {
                  e.target.chart.yAxis[0].addPlotLine(nationalTargetLine);
                }
              },
            },
          };

          if (typeof cadre2.nationalTarget == "number") {
            this.highchart_options.yAxis.plotLines.push(nationalTargetLine);
          }
          if (typeof cadre2.sdgTarget == "number") {
            this.highchart_options.yAxis.plotLines.push(sdgTargetLine);
          }

          var statesNameInOrder = cadre2.top5_yAxis
            .concat(cadre2.noTarget_yAxis)
            .concat(cadre2.least5_yAxis);
          var statesValuesInOrder = cadre2.top5_xAxis
            .concat(cadre2.noTarget_xAxis)
            .concat(cadre2.least5_xAxis);

          let nationalSeriesColor = "#58a5e8";
          let chartData = [];

          if (cadre2.nationalTarget == "") {
            nationalSeriesColor = "#58a5e8";
          } else if (cadre2.national_xAxis[0] > cadre2.nationalTarget) {
            nationalSeriesColor = colorType[color[0]];
          } else {
            nationalSeriesColor = colorType[color[1]];
          }

          let nationalObject = {
            showInLegend: false,
            name: "National Value",
            data: this.convertToObject(
              cadre2.national_xAxis,
              cadre2.national_yAxis
            ),
            pointWidth: 8,
            color: nationalSeriesColor,
          };

          if (cadre2.noTarget_xAxis.length == 37) {
            let national = cadre2.noTarget_xAxis.length - cadre2.national_yAxis;
            for (var i = 0; i < national; i++) {
              cadre2.national_xAxis.push(null);
              cadre2.national_yAxis.push(null);
            }
            var temp = {
              name: "Target not Available",
              data: this.convertToObject(
                cadre2.noTarget_xAxis,
                cadre2.noTarget_yAxis
              ), //data:cadre2.noTarget_xAxis
              pointWidth: 8,
              color: "#58a5e8",
            };

            // this.highchart_options.series.push(nationalObject,temp);
            chartData.push(nationalObject, temp);
          } else {
            var numberOfTargetMet = cadre2.top5_xAxis.length;
            var numberOfTargetNotMet = cadre2.least5_xAxis.length;
            var targetsMet = cadre2.top5_xAxis;
            var targetsNotMet = cadre2.least5_xAxis;

            let national =
              numberOfTargetMet +
              numberOfTargetNotMet -
              cadre2.national_yAxis.length;

            let nationalArrayLength = cadre2.national_yAxis.length;
            var targetsMetObject = {
              name: legendText[color[0]],
              data: this.convertToObject(targetsMet, cadre2.top5_yAxis), //data:targetsMet
              pointWidth: 8,
              color: colorType[color[0]],
            };
            var targetsNotMetObject = {
              name: legendText[color[1]],
              data: this.convertToObject(targetsNotMet, cadre2.least5_yAxis), //data:targetsNotMet
              pointWidth: 8,
              color: colorType[color[1]],
            };
            chartData.push(
              nationalObject,
              targetsMetObject,
              targetsNotMetObject,
              nationalTargetLegend
            );
          }

          this.highchart_options.series = chartData;
          // console.log(this.highchart_options.series);
          // console.log(this.highchart_options.series[1].data.length);
          if(this.data !== undefined) {
          if (
            this.highchart_options.series[1].data.length < 1 ||
            this.highchart_options.series[2].data.length < 1
          ) {
            this.nodata = true;

            if (
              this.highchart_options.series[1].data.length > 2 ||
              this.highchart_options.series[2].data.length > 2
            ) {
              this.nodata = false;
            }

            if (this.highchart_options.series[2].data[0].y == 0) {
              this.nodata = true;
            }
          } else if (this.highchart_options.series[1].data.length == 37) {
            this.nodata = false;
          }
        }
        }
      } else {
        this.plotLGAChart();
      }
    },

    plotNhmisMonthly(indicator) {
      let nhmisMonthlyData = this.$store.state.CAR.NhmisMonthlyData;
      this.nodata = nhmisMonthlyData.length > 0 ? false : true;
      let index = nhmisMonthlyData[0].indexOf(indicator + " -> " + "NHMIS");
      let latestData = nhmisMonthlyData.slice(-36);
      let currentDate = latestData[0][0];
      // let currentData = latestData.filter(val => val[1] == this.selectedState);
      let dataSeries = [];
      latestData.forEach((element) => {
        let temp = {
          name: element[1],
          y: element[index],
        };
        dataSeries.push(temp);
      });

      let sortedData = dataSeries.sort((a, b) => {
        if (a.y > b.y) return -1;
        if (a.y < b.y) return 1;
      });
      let indexNational = sortedData.findIndex((e) => e.name == "National");
      let NationalValue = sortedData[indexNational];
      sortedData.splice(indexNational, 1);
      sortedData.unshift(NationalValue);

      let monthlDataSeries = {
        name: "NHMIS-DHIS2 (monthly)",
        data: sortedData,
        showInLegend: true,
        color: "#13b433",
      };

      this.highchart_options.yAxis.plotLines = "";
      this.highchart_options.subtitle.text =
        this.selectedSource + " / " + currentDate;

      this.highchart_options.series = [];
      this.highchart_options.series.push(monthlDataSeries);
    },

    plotLGAChart() {
      if (
        this.lgaAvailable == false ||
        this.highchart_options.drilldown.series[0].data.length == 0 ||
        this.highchart_options.drilldown.series[0].data[0].y == undefined
      ) {
        this.noSubData = true;
      } else {
        this.noSubData = false;
      }
      this.ndSwitch = "OFF";
      // if(this.lgaAvailable == false ||this.highchart_options.drilldown.series[0].data.length == 0 || this.highchart_options.drilldown.series[0].data[0].y== undefined){
      //                   this.noSubData = true;
      //             } else{
      //                 this.noSubData = false;
      //             }
      this.highchart_options.yAxis.max = null;
      this.theStateName = `${this.stateClicked} State`;
      eventBus.$emit("changedStateName", this.theStateName);
      document.querySelector("#imp").setAttribute("style", "display:none;");
      var indicatorSignalType =
        this.$store.state.CAR.indicatorAttributesOtherSources[
          this.selectedIndicator
        ];
      var stateByIndicatorByYear =
        this.$store.getters.getCurrentIndicatorsValue;

      var indicatorSource =
        this.selectedIndicator + " -> " + this.selectedSource;
      var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
      // get the current year with values for each indicator...
      this.getYearWithCurrentIndicatorValues(
        indexOfindicatorSource,
        stateByIndicatorByYear
      );
      var colorType = ["#13b433", "#1E70EC", "#e85d58"]; // G, B, R
      let legendText = ["On target", "Target not Available", "Not on target"];

      var color = [];
      let text = [];
      if (indicatorSignalType[0][0] === "G") {
        color = [0, 2];
      } else {
        color = [2, 0];
      }
      this.getDrilldownData();
      let data = this.highchart_options.drilldown.series;

      let lgaData = data.find((e) => {
        return e.name === this.stateClicked;
      });

      if (this.nodata == false) {
        if (
          this.lgaAvailable == false ||
          this.highchart_options.drilldown.series[0].data.length == 0 ||
          this.highchart_options.drilldown.series[0].data[0].y == undefined
        ) {
          this.noSubData = true;
        } else {
          this.noSubData = false;
        }
      }
      this.highchart_options.title.text = this.selectedIndicatorShortName;
      this.highchart_options.subtitle.text =
        this.selectedSource + " - " + this.selectedYear;
      this.highchart_options.series = [];
      let series_object = {
        name: this.stateClicked,
        data: lgaData.data,
        showInLegend: false,
        pointWidth: 8,
      };
      let notOnTarget = {
        name: legendText[color[0]],
        color: colorType[color[0]],
        data: null,
        pointWidth: 0,
      };
      let onTarget = {
        name: legendText[color[1]],
        color: colorType[color[1]],
        data: null,
        pointWidth: 0,
      };
      let series_obj = {
        name: this.stateClicked,
        data: lgaData.data,
        showInLegend: true,
        pointWidth: 8,
      };

      let nt_legend = {
        name: "National Target",
        data: this.nationalTarget,
        showInLegend: true,
        pointWidth: 1,
        color: "#222222",
      };

      if (this.nationalTarget == "") {
        this.highchart_options.series.push(series_obj);
      } else {
        this.highchart_options.series.push(
          series_object,
          notOnTarget,
          onTarget,
          nt_legend
        );
      }
    },

    // compute the cadre targets for the different states
    computeCadre2(xAxis, yAxis) {
      //Taking the target value for national
      let nationalTarget;
      let sdgTarget;
      // let targetValues = targetObj["National"];

      this.metaData.map((elem) => {
        if (this.selectedIndicator == elem[0]) {
          nationalTarget = elem[7];
          sdgTarget = elem[10];

          this.nationalTarget = nationalTarget;
          this.sdgTarget = sdgTarget;
        }
      });
      // console.log(sdgTarget1);

      // if(targetValues != ""){
      //   let targetTest = targetValues.toString();
      //   // targetTest = "57 -> 40"
      //   let targetTestArray = targetTest.split("->");
      //   nationalTarget = targetTestArray[0];

      //   if(targetTestArray[0] != ""){
      //     nationalTarget = parseInt(targetTestArray[0]);
      //   }
      //   if(targetTestArray.length > 1){
      //     sdgTarget = parseInt(targetTestArray[1]);
      //     // console.log(targetTestArray);
      //     // console.log(sdgTarget);
      //   }
      // }

      let national_xAxis = [];
      let national_yAxis = [];
      let top5_xAxis = [];
      let top5_yAxis = [];
      let noTarget_xAxis = [];
      let noTarget_yAxis = [];
      let least5_xAxis = [];
      let least5_yAxis = [];
      yAxis.map((elem, index) => {
        if (elem === "National") {
          national_xAxis.push(xAxis[index]);
          national_yAxis.push(yAxis[index]);

          this.maxValue =
            this.maxValue < xAxis[index] ? xAxis[index] : this.maxValue;
        } else {
          // if (targetObj[elem] == "") {
          if (nationalTarget == "") {
            noTarget_xAxis.push(xAxis[index]);
            noTarget_yAxis.push(yAxis[index]);

            this.maxValue =
              this.maxValue < xAxis[index] ? xAxis[index] : this.maxValue;
            // } else if (targetObj[elem] <= xAxis[index]) {
          } else if (nationalTarget <= xAxis[index]) {
            top5_xAxis.push(xAxis[index]);
            top5_yAxis.push(yAxis[index]);

            this.maxValue =
              this.maxValue < xAxis[index] ? xAxis[index] : this.maxValue;
          } else {
            least5_xAxis.push(xAxis[index]);
            least5_yAxis.push(yAxis[index]);

            this.maxValue =
              this.maxValue < xAxis[index] ? xAxis[index] : this.maxValue;
          }
        }
      });
      return {
        national_xAxis,
        national_yAxis,
        nationalTarget, // targetValue,
        sdgTarget,
        top5_xAxis,
        top5_yAxis,
        noTarget_xAxis,
        noTarget_yAxis,
        least5_xAxis,
        least5_yAxis,
      };
    },
    getYearWithCurrentIndicatorValues(
      indexOfindicatorSource,
      stateByIndicatorByYear
    ) {
      var statesWithIndicatorsYearAndValues = {};
      var tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value
      var sourceActiveYear = {};
      var sourcetempArr = [];

      for (var stateName in stateByIndicatorByYear) {
        if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
          for (
            var i = stateByIndicatorByYear[stateName].length - 1;
            i >= 0;
            i--
          ) {
            statesWithIndicatorsYearAndValues[stateName] = [];
            var selectedIndicatorVal =
              stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            if (
              stateByIndicatorByYear[stateName][i][0] ===
              parseInt(this.selectedYear)
            ) {
              tempArr[stateName] = i;
              statesWithIndicatorsYearAndValues[stateName].push(
                stateByIndicatorByYear[stateName][i][0],
                stateByIndicatorByYear[stateName][i][indexOfindicatorSource]
              );
              break;
            }
          }
          // get all the years where there's a value for the indicator...
          for (
            var i = stateByIndicatorByYear[stateName].length - 1;
            i >= 0;
            i--
          ) {
            if (!sourceActiveYear[stateName]) {
              sourceActiveYear[stateName] = {};
            }
            var selectedIndicatorVal =
              stateByIndicatorByYear[stateName][i][indexOfindicatorSource];

            if (selectedIndicatorVal) {
              sourcetempArr.push(i);
              sourceActiveYear[stateName][
                stateByIndicatorByYear[stateName][i][0]
              ] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            }
          }
        }
      }
      // we leverage the fact that National always has data for all the indicators
      // O we changed our minds and no longer leverage the above
      // We expect the value to be national or next state if national is empty

      let year = [];
      for (let i in sourceActiveYear) {
        let tempObj = sourceActiveYear[i];
        let tempYears = Object.keys(tempObj);
        year = this.$_.union(year, tempYears);
      }

      // this.optionYear = year;
      this.optionYear = year.sort(function (a, b) {
        return b - a;
      }); //Object.keys(sourceActiveYear["National"]);

      this.$emit("optionYear", this.optionYear);
      var rowIndex = Math.max.apply(null, tempArr);

      return [statesWithIndicatorsYearAndValues, rowIndex, tempArr];
    },
  },
  computed: {
    sourceClicked() {
      //for tablecomponent.vue
      let tempSource = this.$store.getters.getTableSourceClicked;
      // console.log(tempSource);

      if (this.lsData) {
        // for customtable.vue
        /**
         * Dynamically select a particular source to be used for the bar chart
         */

        let indicatorSourceIndex, indicator_source;

        if (Array.isArray(tempSource)) {
          this.sortByLatestAvailableYear();
          this.sourceOptions = tempSource;
          // return singleSource;
          // console.log(singleSource);
          // console.log(this.selectedSource);
        } else {
          this.selectedSource = tempSource;
          indicator_source = this.selectedIndicator + " -> " + tempSource;
          indicatorSourceIndex = this.lsData[0].indexOf(indicator_source);
          // return tempSource;
        }
        // console.log(tempSource);
      }
    },
    indicatorSelected() {
      this.selectedIndicator = this.$store.getters.getSelectedIndicator;

      var temp = this.$store.getters.getShortIndicatorNames(
        this.selectedIndicator
      );
      // console.log(this.selectedIndicator);

      return "Some values";
    },
    selectedIndicatorShortName() {
      // send message to reset list of sources...
      return this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
    },
  },
  created() {
    // get the program area indicator grouping

    this.highchart_options.chart.type = "bar";
    this.highchart_options.plotOptions.series.cropThreshold = 300;
    this.highchart_options.subtitle.text = "Loading...";
    this.highchart_options.legend = {
      // layout: 'vertical',
      align: "center",
      verticalAlign: "bottom",
      x: -20,
      y: 10,
      itemStyle: {
        fontSize: "12px",
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: "600",
      },
      // floating: false,
      // borderWidth: 1,
      // shadow: true
    };
    this.highchart_options.xAxis.title.text = "";
    // this.highchart_options.xAxis.lineWidth = 2;
    this.highchart_options.yAxis.gridLineWidth = 1;
    this.highchart_options.yAxis.title.text = "";
    this.highchart_options.plotOptions.colorByPoint = true;
    this.highchart_options.chart.height = 670;
  },
  async mounted() {
    // const clearDB = localStorage.getItem('cleardb')
    // if (clearDB !== 'done'){
    //   localStorage.clear();
    //   localStorage.setItem('cleardb', 'done')
    // }
    // console.log('already cleared db')

    this.sourceOptions = [
      "MICS",
      "NDHS",
      "NARHS",
      "NMIS",
      "NNHS",
      "NHMIS",
      "World Bank",
      "IHME",
      "WHO-GHO",
    ];
    await this.getIdb();
    //this.ndLgaData = this.fetchNdLgaData();

    eventBus.$on("chartToggleEvent", (data) => {
      this.showToggle = data;
    });

    this.selectedSource = "NHMIS";
    this.ndStateData = await this.getIdb();
    this.ndIndexState = this.getIndicatorSourceIndex(this.ndStateData);

    this.fetchNdLgaData().then((ndLgaData) => {
      this.ndLgaData = ndLgaData.data;
      this.ndIndexLga = this.getIndicatorSourceIndex(this.ndLgaData);
    });

    // this.ndLgaData = JSON.parse(this.$ls.get("nd_lga_data"))
    // this.ndIndexLga = this.getIndicatorSourceIndex(this.ndLgaData)
    //console.log(this.ndStateData)
    //console.log(this.ndLgaData)
    //this.ndFilterByYear()

    this.tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
    let tempSource = this.$store.getters.getTableSourceClicked;
    var sources = this.tableColumnHeaderAttr[0];
    // var selectedSource = sources; //? sources: defaultSource;
    this.sortByLatestAvailableYear();
    if (this.dashboardStateOptions.length > 0) {
      this.selectedIndicator = this.dashboardStateOptions[0];
      this.selectedYear = this.dashboardStateOptions[2];
    } else {
      this.selectedIndicator = "Skilled attendance at delivery or birth";
      //this.selectedYear = '2017';
    }
    if (this.lgaData && this.metaData) {
      // call get indicator to get indicators
      if (this.lsData) {
        this.optionYear = this.$store.getters.getOtherDatasetYear;
        // this.ls_lgaData = this.$store.getters.getLgaData;
        this.isDataLoadedFirstTime = true;

        // this.ls_lgaData = this.lgaData;
        this.splitLGADistrict();
        // this.ls_lgaData = this.lga;
        this.plotStateChart();
        this.selectedYear = Math.max.apply(null, this.optionYear);
      }
      if (this.metaData) {
        this.getDisplayFactor();
      }
    }
    this.getNdChartData();
    // this.selectedSource = "NHMIS";
    // this.selectedYear = "2020"
  },
  updated() {},
  watch: {
    async ndSwitch(val) {
      if (val == "OFF") {
        this.highchart_options.plotOptions.series.dataLabels.format =
          "{point.y:.1f}";
      }

      if (this.stateClicked == "National") {
        this.ndStateData = await this.getIdb();
        this.ndIndexState = this.getIndicatorSourceIndex(this.ndStateData);
        this.plotStateND();
      } else {
        this.plotLgaND();
      }
    },
    selectedIndicator(val) {
      // if(this.metaData && this.ls_lgaData){
      // console.log(this.sourceOptions);
      this.sortByLatestAvailableYear();
      if (this.metaData) {
        setTimeout(() => {
          this.splitLGADistrict();
          this.plotStateChart();
          this.getDisplayFactor();
        }, 5);
      }
    },
    selectedSource(val) {
      if (val) {
        this.selectedYear = this.getSourceYear(val);

        // if (this.metaData && this.ls_lgaData) {
        /* fires event when selectedSource is changed*/
        eventBus.$emit("barSourceEvent", val);
        if (this.metaData) {
          setTimeout(() => {
            this.splitLGADistrict();
            this.plotStateChart();
            this.getDisplayFactor();
            // console.log(this.optionYear);
          }, 1);
          this.ndSwitch = "OFF";
        }
      }
    },
    async selectedYear(val) {
      //this.ndStateData = await this.getIdb();
      //this.ndIndexState = this.getIndicatorSourceIndex(this.ndStateData);
      //this.lsTargetData = this.$store.getters.getTargetData;
      //this.plotStateND();
      // eventBus.$emit("computeNd", val);
      if (this.lsData) {
        // if (this.metaData && this.ls_lgaData) {
        if (this.metaData) {
          // this.splitLGADistrict();
          this.plotStateChart();
          this.$emit("callerName", "barChartComponentYear");
          this.$emit("selectedYear", val);
        }
      }
    },

    appData(val) {
      if (!this.lsData) {
        this.lsData = val;
        this.isDataLoadedFirstTime = true;
        // if (this.metaData && this.ls_lgaData) {
        if (this.metaData) {
          this.getDisplayFactor();
          this.plotStateChart();
        }
        // if(this.metaData){
        //   this.getDisplayFactor();
        // }
      }
      // call method ...
    },
    metaData(val) {
      if (val) {
        this.metaData = val;
        this.getDisplayFactor();
        this.plotStateChart();
      }
    },
    lgaData(val) {
      if (val) {
        this.splitLGADistrict();
        // this.ls_lgaData = this.lga;
        if (this.metaData) {
          this.plotStateChart();
        }
      }
    },
    dashboardStateOptions(val) {
      if (val) {
        this.selectedIndicator = val[0];
        this.selectedYear = val[2];
      }
    },
    stateClicked(val) {
      this.plotStateChart();
      // if(val !== 'National') {

      // }
    },
    optionYear() {
      // this.selectedYear= this.optionYear[0]
    },
  },
};
</script>

<style scoped>
div[class^="col"] {
  padding-left: 7px;
  padding-right: 7px;
}

.rowlTop {
  margin-bottom: -30px !important;
}

.rowlBot {
  margin-top: -30px !important;
}
span#span-extra {
  background-color: #222222;
  border-radius: 50%;
  display: inline-block;
  width: 12px;
  height: 12px;
}
.noSubDataMockUp {
  width: 55%;
  height: 50%;
  position: absolute;
  top: 21%;
  left: 25%;
  /* border:10px 2; */
  text-align: center;

  font-size: 13px;
  font-weight: 200;
  padding: 4%;
}
.infoi {
  width: 55%;
  height: 50%;
  position: absolute;
  top: 22%;
  left: 25%;
  /* border:10px 2; */
  text-align: center;
  border-style: groove;
  font-size: 13px;
  font-weight: 200;
  padding: 4%;
}
p#imp {
  display: none;
  font-size: 12px;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  color: #333333;
}

/* Some styles live in App.vue file*/
</style>


// WEBPACK FOOTER //
// barChartComponent.vue?3db1af38